import { useState } from "react";
import { toast } from "sonner";
import { Loader2, PartyPopper, X } from "lucide-react";
import { api, formatApiError } from "../lib/api";

const inputCls = "mt-1.5 w-full rounded-lg border border-[#e3e0d3] px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#94a01a]";
const labelCls = "text-xs uppercase tracking-[0.15em] font-medium text-[#51637a]";

export function FoundEmploymentDialog({ onClose, onDone }) {
  const [busy, setBusy] = useState(false);
  const [f, setF] = useState({ employer_name: "", role_title: "", through_ditch: null, note: "" });
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/candidate/found-employment", f);
      toast.success("Congratulations! We've let the team know 🎉");
      onDone?.();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/50 p-4 py-10" data-testid="found-employment-dialog">
      <div className="relative w-full max-w-lg rounded-2xl bg-[#f5f3ee] p-6 sm:p-8">
        <button onClick={onClose} data-testid="found-emp-close"
          className="absolute right-4 top-4 rounded-full p-1.5 text-[#51637a] hover:bg-[#e3e0d3]"><X size={18} /></button>
        <div className="mb-5 pr-8">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#C1CC24]/25 text-[#7C8514]"><PartyPopper size={20} /></span>
          <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-[#0d2f4d]">You've found a job — amazing!</h2>
          <p className="mt-2 text-sm text-[#51637a]">Let us know a few details (all optional) and we'll update your file and stop matching you to new roles.</p>
        </div>
        <div className="space-y-5">
          <div><label className={labelCls}>Where are you starting? (employer)</label><input className={inputCls} data-testid="found-employer" value={f.employer_name} onChange={(e) => set("employer_name", e.target.value)} placeholder="Company name" /></div>
          <div><label className={labelCls}>Role title</label><input className={inputCls} data-testid="found-role" value={f.role_title} onChange={(e) => set("role_title", e.target.value)} placeholder="e.g. Head Chef" /></div>
          <div>
            <label className={labelCls}>Did you find it through The Ditch?</label>
            <div className="mt-1.5 flex gap-2">
              {[["Yes", true], ["No", false]].map(([lbl, val]) => (
                <button type="button" key={lbl} data-testid={`found-through-${lbl.toLowerCase()}`} onClick={() => set("through_ditch", val)}
                  className={`rounded-full border px-6 py-2 text-sm font-medium ${f.through_ditch === val ? "border-[#0d2f4d] bg-[#0d2f4d] text-[#C1CC24]" : "border-[#e3e0d3] text-[#0d2f4d]"}`}>{lbl}</button>
              ))}
            </div>
          </div>
          <div><label className={labelCls}>Anything you'd like to share?</label><textarea rows={3} className={inputCls} data-testid="found-note" value={f.note} onChange={(e) => set("note", e.target.value)} /></div>
          <button onClick={submit} disabled={busy} data-testid="found-submit"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#C1CC24] px-8 py-4 text-base font-bold text-[#0d2f4d] transition-colors hover:bg-[#aeb81f] disabled:opacity-60">
            {busy && <Loader2 className="h-5 w-5 animate-spin" />} Let the team know
          </button>
        </div>
      </div>
    </div>
  );
}
